import React from 'react';
import { EventMetadataContext } from './event-metadata';

/**
 * Returns true when the surrounding event-panel context is rendering a cleared event.
 * Returns false outside any event-panel context — the entity-panel form components are
 * shared with the bolo panel (which has no EventMetadataProvider), and reading the
 * event metadata via {@link useEventMetadataStore} would throw there. RND-57756 added
 * this hook to those shared components, so it must degrade gracefully when no provider
 * is present rather than crash the host panel.
 */
export function useIsClearedEvent() {
    const store = React.useContext(EventMetadataContext);
    const eventInfo = store?.state?.metadata;
    return eventInfo?.eventId ? !eventInfo?.isActive : false;
}
